<div #tabNavigation class="absolute inset-0 flex items-end overflow-hidden bg-black">
  <div class="flex items-end">
    @if (authService.currentUser()) {
      <app-open-vehicle-selection-button type="icon" class="mb-[10px] rounded-lg bg-white" />
    }

    <div class="flex items-end overflow-hidden px-3">
      @for (tab of visibleTabs(); track tab._id) {
        <div
          class="group relative h-16 min-w-[250px] max-w-[250px] truncate"
          [ngClass]="{
            'flex items-center justify-center': true,
            'rounded-bottom rounded-t-lg bg-white text-black': tab._id === tabService.activeTab()?._id,
            'bg-black text-white': tab._id !== tabService.activeTab()?._id,
          }"
          data-testid="vehicle-tab">
          <button
            (click)="navigateToTab(tab)"
            class="overflow-hidden px-4"
            [ngClass]="{
              'border-r border-stone-200':
                (tab._id !== tabService.activeTab()?._id && !isLeftOfActiveTab($index) && $index !== visibleTabs().length - 1) ||
                (isNextToOverflowButton($index) && tab._id !== tabService.activeTab()?._id),
            }"
            [attr.data-active]="tab._id === tabService.activeTab()?._id">
            <app-tab-button [tab]="tab" [hideCloseButton]="true" [darkMode]="tab._id !== tabService.activeTab()?._id" />
          </button>

          <app-close-tab-button
            [tab]="tab"
            class="!absolute inset-y-0 right-1 hidden rounded-lg bg-gradient-to-r from-transparent to-50% pl-8 pr-2 group-hover:block"
            [ngClass]="{
              'to-white': tab._id === tabService.activeTab()?._id,
              'to-black': tab._id !== tabService.activeTab()?._id,
            }"
            iconClass="!w-4 !h-4"
            (onClose)="onTabClose()" />
        </div>
      }
    </div>

    <button
      class="mb-2 flex items-center justify-center rounded-lg p-3 !text-white hover:bg-stone-800"
      (click)="overflowPopover.toggle($event)"
      [ngClass]="{
        '!hidden': overflowingTabs().length === 0,
      }"
      [disabled]="overflowingTabs().length === 0">
      <i class="pi pi-list"></i>
    </button>
    <p-popover #overflowPopover styleClass="user-menu-popover" [style]="{ maxWidth: '450px', maxHeight: '80vh', overflowY: 'auto' }">
      <div class="flex flex-col">
        @for (tab of overflowingTabs(); track tab._id) {
          <div class="group flex px-2 py-4 hover:bg-stone-100">
            <button class="group flex-1 overflow-hidden px-4" (click)="navigateToTab(tab)">
              <app-tab-button [tab]="tab" [hideCloseButton]="true" />
            </button>
            <app-close-tab-button
              [tab]="tab"
              class="mr-2 p-2 text-stone-500 hover:text-black"
              iconClass="!w-4 !h-4"
              (onClose)="closeOverflowingTabs()" />
          </div>
        }
      </div>
    </p-popover>
  </div>
</div>
